import * as _actions from './actions';
import _reducer from './reducer';
import _OnlineHomework from './model';
import create from './create';

_OnlineHomework.actions = _actions;
_OnlineHomework.create = create;

export const actions = _actions;
export const reducer = _reducer;
export const OnlineHomework = _OnlineHomework;



// WEBPACK FOOTER //
// ./data/OnlineHomework/index.js